export const FLAG_GETTING_COMPANY_TICKETS = 'FLAG_GETTING_COMPANY_TICKETS';
export const GET_COMPANY_TICKETS = 'GET_COMPANY_TICKETS';
export const CLEAR_COMPANY_TICKETS = 'CLEAR_COMPANY_TICKETS';
export const FLAG_COMPANY_TICKET_ACTIVITY = 'FLAG_COMPANY_TICKET_ACTIVITY';
export const GET_COMPANY_TICKET = 'GET_COMPANY_TICKET';
export const CLEAR_COMPANY_TICKET = 'CLEAR_COMPANY_TICKET';
